import { gql } from '@apollo/client'
import { GET_SELLERS_DATA } from 'src/actions'
import { dispatchQueryGQL } from '../../gqlActions'

const GET_SELLERS = gql`
  query GetSalesAgents {
    getSalesAgents {
      bioImagePath
      calendlyCS
      email
      calendlyMG
      fax
      name
      productsList
      states
      tollFreePhone
    }
  }
`
export const getSellersGQL = () => {
  return dispatchQueryGQL({
    query: GET_SELLERS,
    type: GET_SELLERS_DATA,
    key: 'getSalesAgents'
  })
}
